import React from 'react';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 border-t border-gray-200" data-id="element-384" data-mp="10gdu3q01jkld">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-385" data-mp="20q46ib0cvxbm">
        <div className="text-center mb-12" data-id="element-386" data-mp="1n0ae5ipn6ux5">
          <div className="flex justify-center space-x-2 mb-8" data-id="element-387" data-mp="1mzivf8h58roa">
            <button className="w-3 h-3 rounded-full bg-[#214ae9]" data-id="element-388" data-mp="1r141oaz6a7pi"></button>
            <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-389" data-mp="1d1unthyfvpop"></button>
            <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-390" data-mp="1d0jktkctilyn"></button>
          </div>
          <blockquote className="text-xl md:text-2xl font-semibold text-[#111111] max-w-4xl mx-auto leading-snug" data-id="element-391" data-mp="1i2io6u8k5ivl">
            "I used to spend hours every month helping my parents with their
            tech problems. Now they're actually confident — and I got my
            weekends back."
          </blockquote>
          <div className="mt-8" data-id="element-392" data-mp="2yd34cp2sbbb3">
            <p className="text-[#111111] font-semibold" data-id="element-393" data-mp="32gj2jpui5jpw">Sarah Chen</p>
            <p className="text-gray-500 text-sm" data-id="element-394" data-mp="32eolwnq9kdrm">
              Guardian for her parents, ages 68 and 71
            </p>
          </div>
        </div>
      </div>
    </section>;
}